import React, { useState, useEffect } from "react";
import Card from "../../../components/Card";
import { Row, Col, Button } from "react-bootstrap";
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import { postApiCall } from "../../../service/httpCall";
import { API_VOICE_PLAN_CREATE } from "../../../service/url";
import { useNavigate } from "react-router-dom";
import {
  ROUTES,
} from "../../../utilities/constant";
import RenderVoicePlanForm from "./_form";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { getUser } from "../../../utilities/setting";
import { DeleteIcon} from '../../../components/setting/elements';



export default function VoicePlanCreate() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [planName, setPlanName] = useState("");
  const [planType, setPlanType] = useState("");
  const [pulseDuration, setPulseDuration] = useState("");
  const [pulsePrice, setPulsePrice] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [userPulseDuration, setUserPulseDuration] = useState(null)
  const [userPulsePrice, setUserPulsePrice] = useState(Infinity)
  const [plansData, setPlansData] = useState([])
  const [currentPlan, setCurrentPlan] = useState([]);
  const [planNameError, setPlanNameError] = useState("");


  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);

  function validateForm() {
    let valid = true;

    if (!planName) {
      valid = false;
      toast.warning("Plan Name required")
    } else if (plansData.length == 0) {
      valid = false;
      toast.warning("Plan Data required")
    } else {
      // Validate all prices have max 4 decimal places
      for (let i = 0; i < plansData.length; i++) {
        const plan = plansData[i];
        if (plan.pulse_price !== undefined && plan.pulse_price !== null) {
          const priceStr = plan.pulse_price.toString();
          const decimalParts = priceStr.split('.');
          if (decimalParts.length > 1 && decimalParts[1].length > 4) {
            valid = false;
            toast.warning(`Price at row ${i + 1} must have maximum 4 decimal places`);
            break;
          }
        }
      }
    }

    return valid;
  }

  function submitForm(e) {
    e.preventDefault();

    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    // Ensure all pulse_price and pulse_duration are numbers
    const normalizedPlans = plansData.map(plan => ({
      ...plan,
      pulse_price: typeof plan.pulse_price === 'string' ? parseFloat(plan.pulse_price) : Number(plan.pulse_price),
      pulse_duration: typeof plan.pulse_duration === 'string' ? parseInt(plan.pulse_duration, 10) : Number(plan.pulse_duration)
    }));

    let params = {
      plan_name: planName,
      plans : normalizedPlans
    };

    postApiCall(API_VOICE_PLAN_CREATE, params)
      .then(onVoicePlanSuccess)
      .catch(onVoicePlanError);
  }

  function onVoicePlanSuccess(resp) {
    toast.success("Voice plan created successfully")
    setTimeout(() => {
      navigate(`/${ROUTES.VOICE_PLAN.LIST}`);
    }, 1500);
  }

  function onVoicePlanError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   }
    setButtonDisable(false);
    toast.warning(err)
  }

  useEffect(() => {
    const user = getUser();

        if (user?.voice_plan_id) {
          setUserPulseDuration(user.voice_plan_id.pulse_duration)
          setUserPulsePrice(user.voice_plan_id.price)
        }

    }, []);

    const handleRemovePlan = (data) => {
      setPlansData((prevData) =>
        prevData.filter((plan) => plan.plan_type !== data.plan_type)
      );
      setCurrentPlan((prevData) =>
        prevData.filter((plan) => plan !== data.plan_type)
      );
    };

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">
                    New Voice Plan Information
                  </h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-trunk-info"></div>

                <form
                  onSubmit={async (e) => {
                    submitForm(e);
                  }}
                >
                  <RenderVoicePlanForm
                    planName={planName}
                    setPlanName={setPlanName}
                    pulseDuration={pulseDuration}
                    setPulseDuration={setPulseDuration}
                    pulsePrice={pulsePrice}
                    setPulsePrice={setPulsePrice}
                    setUserPulsePrice = {setUserPulsePrice}
                    userPulsePrice = {userPulsePrice}
                    userPulseDuration = {userPulseDuration}
                    setUserPulseDuration = {setUserPulseDuration}
                    setPlanType = {setPlanType}
                    planType = {planType}
                    setPlansData = {setPlansData}
                    plansData = {plansData}
                    currentPlan = {currentPlan}
                    setCurrentPlan = {setCurrentPlan}
                    setPlanNameError = {setPlanNameError}
                  />

                  <div className="mt-4">
                            <h5>Assigned Voice plan</h5>
                            <table className="table table-bordered" style={{ marginTop: "20px" }}>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Plan Name</th>
                                        <th>Plan Duration</th>
                                        <th>Plan Price</th>
                                        <th>Plan Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plansData.length > 0 ? (
                                        plansData.map((data, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{planName}</td>
                                                <td>{data.pulse_duration}</td>
                                                <td>{data.pulse_price}</td>
                                                <td>{data.plan_type}</td>
                                                <td>
                                                    <div className="actions" style={{ display: 'flex', gap: '5px' }}>
                                                        <div>
                                                            <DeleteIcon
                                                                title="Delete"
                                                                handleCallback={() => handleRemovePlan(data)}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">No Plans Found</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                  </div>

                  <Button
                    type={"submit"}
                    variant="btn btn-primary"
                    disabled={buttonDisable || plansData.length === 0 || planNameError}
                  >
                    Add Voice Plan &nbsp;
                    {buttonDisable ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <></>
                    )}
                  </Button>
                </form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
}
